import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./style.css";
import "./input.css";
import { RiHomeHeartLine, RiLinkedinBoxLine } from "react-icons/ri";
import { GoMail } from "react-icons/go";

function Contact() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = `mailto:muhammadashirone@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="Contact py-5 border-bottom" id="contact">
      <div className="container-lg">
        <div className="Contact__headings my-4 fs-5">
          <span
            className="Contact__headings--small text-uppercase"
            data-aos={"fade-out"}
            data-aos-duration={1500}
            data-aos-offset={5}
          >
            _Contact
          </span>
          <h1
            className="Contact__headings--h1 my-3"
            data-aos={"fade-out"}
            data-aos-duration={1500}
            data-aos-offset={8}
          >
            Contact Me
          </h1>
          <h4 className="Contact__headings__detail">
            Maximize your online presence and rise above the competition with my
            help. Partner with me to elevate your business to new heights and
            reach your goals in the digital world.
          </h4>
        </div>
        <div className="row mt-5">
          <div className="col-md-6 col-11">
            <div
              className="Contact__info mt-5"
              data-aos={"fade-right"}
              data-aos-duration={1200}
              data-aos-offset={60}
            >
              <div className="Contact__info__list mt-4">
                <div className="Contact__info__list__item d-flex align-items-center mt-4">
                  <RiHomeHeartLine className="Contact__info__list__item__icon fs-2 me-3" />
                  <div className="Contact__info__list__item__text d-flex flex-column">
                    <span className="Contact__info__list__item__text__heading">
                      Faisalabad, Pakistan
                    </span>
                    <small className="Contact__info__list__item__text--small">
                      Sehgal city
                    </small>
                  </div>
                </div>
                <div className="Contact__info__list__item d-flex align-items-center mt-4">
                  <GoMail className="Contact__info__list__item__icon fs-2 me-3" />
                  <div className="Contact__info__list__item__text d-flex flex-column">
                    <a
                      href="mailto:muhammadashirone@gmail.com?subject="
                      subject="Query"
                      rel="noreferrer"
                      className="Contact__info__list__item__text__heading Contact__info__list__item__text--link "
                    >
                      muhammadashirone@gmail.com
                    </a>
                    <small className="Contact__info__list__item__text--small">
                      Send me your query anytime!
                    </small>
                  </div>
                </div>
                <div className="Contact__info__list__item d-flex align-items-center mt-4">
                  <RiLinkedinBoxLine className="Contact__info__list__item__icon fs-2 me-3" />
                  <div className="Contact__info__list__item__text d-flex flex-column">
                    <a
                      href="https://www.linkedin.com/in/muhammad-ashir-153135235/"
                      target="-blank"
                      className="Contact__info__list__item__text__heading Contact__info__list__item__text--link"
                    >
                      My LinkedIn Profile
                    </a>
                    <small className="Contact__info__list__item__text--small">
                      Here to build a connection!
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <form
              onSubmit={handleSubmit}
              className="Contact__form mt-md-0 mt-5"
              data-aos={"fade-right"}
              data-aos-duration={1200}
              data-aos-offset={80}
            >
              <div className="row">
                <div className="col-12 my-2">
                  <input
                    type="text"
                    className="form-control form-control-lg bg-white fs-6"
                    id="name"
                    name="name"
                    placeholder="Enter Your Name"
                  />
                </div>
                <div className="col-12 my-2">
                  <input
                    type="email"
                    className="form-control form-control-lg fs-6"
                    id="address"
                    name="address"
                    placeholder="Enter Email Address"
                  />
                </div>
                <div className="col-12 my-2">
                  <input
                    type="text"
                    className="form-control form-control-lg fs-6"
                    id="subject"
                    name="subject"
                    value={subject}
                    placeholder="Enter Subject"
                    onChange={(e) => setSubject(e.target.value)}
                    required
                  />
                </div>
                <div className="col-12 my-2">
                  <textarea
                    className="form-control px-3"
                    name="message"
                    id="message"
                    cols="71"
                    rows="5"
                    placeholder="Enter Your Message Here!"
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    required
                  ></textarea>
                </div>
                <div className="col-12 my-2 d-flex justify-content-end">
                  <input
                    type="submit"
                    value="Send"
                    className="Contact__form__button px-4 py-2 ms-auto mt-3"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
